'use strict';

var template    = require('../../templates/dashboard/Layout.ejs');
var ActionLogView = require('commons/views/ActionLog');
var LeaveView     = require('./Leave');

module.exports = Backbone.View.extend({
    initialize: function() {
        this.render();
    },

    render: function() {
        this.$el.html(template());
        return this;
    },

    renderDefault: function(options) {
        this.$('.js-leave-loader').hide();
        this.$('.js-isNotSetUp').show();
        this.$('.js-isSetUp').hide();
        this.$('.js-contact-link').attr(
            'href',
            'mailto:' + options.company.get('contactEmail')
        ).html(options.company.get('contactEmail'));
    },

    renderActionLog: function(options) {
        this.actionLog = new ActionLogView({
            collection: options.collection,
            fetchMore: options.fetchMore,
            layerMap: options.layerMap
        });
        this.$('.js-action-log').html(this.actionLog.render().el);
        this.$('.js-action-log-loader').hide();
    },

    renderLeave: function(options) {
        var self = this;
        self.leave = new LeaveView(
            _.extend({$el: self.$('.js-leave')}, options)
        );
        self.$('.js-leave-loader').hide();
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/dashboard/Layout.js